const sectionStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 10px 25px rgba(0,0,0,0.08)"
    : "none";
  e.currentTarget.style.transform = enter
    ? "translateY(-2px)"
    : "translateY(0)";
};

const EndToEndOwnership = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "42px", marginBottom: "20px" }}>
          End-to-End Ownership
        </h1>

        <p style={{ fontSize: "20px", color: "#555", maxWidth: "700px" }}>
          I take full responsibility for delivering cloud solutions—from initial idea and architecture,
          through implementation, to optimization and long-term maintenance.
        </p>
      </div>


      {/* WHAT THIS MEANS */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>
          What This Means for Your Project
        </h2>

        <div style={gridStyle}>
          {[
            "Single point of responsibility for your cloud solution",
            "Consistency across architecture, development, and deployment",
            "Faster delivery with fewer handoffs and miscommunication",
            "Practical solutions designed for real-world production use",
            "Alignment between business goals and technical implementation",
            "Reduced risk in complex cloud projects"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* DELIVERY FLOW (VISUAL LINE) */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "20px" }}>Delivery Flow</h2>

        <p style={{ color: "#555", fontSize: "16px" }}>
          Idea → Architecture → PoC → Build → Deploy → Optimize → Scale
        </p>
      </div>


      {/* DELIVERY PHASES */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>Delivery Phases</h2>

        <div style={gridStyle}>
          {[
            {
              title: "1. Discovery & Consulting",
              text: "Understanding business goals, constraints, and existing systems. Identifying the right approach and defining the scope."
            },
            {
              title: "2. Architecture Design",
              text: "Designing scalable, secure, and cost-efficient AWS architectures aligned with best practices."
            },
            {
              title: "3. Proof of Concept (PoC)",
              text: "Validating key assumptions and technologies through working prototypes before full implementation."
            },
            {
              title: "4. Implementation",
              text: "Building production-ready systems using Java, Python, and AWS services with Infrastructure as Code."
            },
            {
              title: "5. Deployment & CI/CD",
              text: "Setting up automated pipelines and ensuring reliable, repeatable deployments."
            },
            {
              title: "6. Optimization & Scaling",
              text: "Improving performance, reducing costs, and ensuring scalability under real workloads."
            },
            {
              title: "7. Maintenance & Evolution",
              text: "Ongoing improvements, monitoring, and adapting the system as business needs grow."
            }
          ].map((phase, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              <h3 style={{ marginBottom: "10px" }}>{phase.title}</h3>
              <p style={{ color: "#555" }}>{phase.text}</p>
            </div>
          ))}
        </div>
      </div>


      {/* WHAT I DELIVER */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "30px" }}>What I Deliver</h2>

        <div style={gridStyle}>
          {[
            "Production-ready cloud systems (not prototypes)",
            "Clean, maintainable codebases",
            "Infrastructure as Code (CloudFormation, Terraform, AWS SAM)",
            "Automated CI/CD pipelines",
            "Scalable and resilient architectures",
            "Monitoring and observability setup",
            "Documentation and knowledge transfer"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* WHERE THIS WORKS BEST */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>Where This Approach Works Best</h2>

        <div style={gridStyle}>
          {[
            "Building new cloud-native applications from scratch",
            "Modernizing legacy systems into AWS",
            "Scaling existing systems to handle growth",
            "Projects requiring both architecture and implementation",
            "Teams lacking in-house AWS expertise",
            "Complex integrations across multiple systems"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* WHY IT MATTERS */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "30px" }}>Why It Matters</h2>

        <div style={gridStyle}>
          {[
            "Eliminates gaps between architecture and implementation",
            "Reduces project risk and technical debt",
            "Ensures faster and more predictable delivery",
            "Avoids over-engineering and unnecessary complexity",
            "Creates systems ready for real production workloads",
            "Provides long-term maintainability and scalability"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>

      {/* FINAL CTA */}
      <div style={{
        textAlign: "center",
        margin: "100px 0",
        padding: "60px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{
          fontSize: "32px",
          marginBottom: "16px"
        }}>
          Let’s Build Your System End-to-End
        </h2>

        <p style={{
          color: "#555",
          fontSize: "18px",
          marginBottom: "32px",
          maxWidth: "600px",
          marginLeft: "auto",
          marginRight: "auto",
          lineHeight: "1.6"
        }}>
          If you need someone who can take your idea and turn it into a scalable,
          production-ready AWS system, let’s talk.
        </p>

        <a href="/contact" style={{
          display: "inline-block",
          padding: "16px 36px",
          background: "#007bff",
          color: "#fff",
          borderRadius: "8px",
          textDecoration: "none",
          fontWeight: "500",
          fontSize: "16px",
          transition: "all 0.2s ease",
          boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
        }}
        >
          Start a Project
        </a>
      </div>


    </div>
  );
};

export default EndToEndOwnership;